import type { IWatermarkElement } from '@/types/watermarks.types';
import styles from '../watermark.module.css';
import type { CSSProperties } from 'react';
const ImageEl = (el: IWatermarkElement) => {
  const { url } = el.settings.image;
  const { height, width } = el.settings.dimensions;

  return (
    <img
      draggable={false}
      src={url}
      className={el.settings.duration === 'pulse' ? styles.pulse : ''}
      style={
        {
          userSelect: 'none',
          opacity: 'var(--wm-opacity)',
          height: height ?? 100,
          width: width ?? 'auto',
          '--wm-opacity': el.settings.opacity ?? 1,
        } as CSSProperties
      }
    />
  );
};

export default ImageEl;
